/**
 * Element-level Enter/S/H for answer controls that are `<input>`s (the MC
 * options and the confidence rating). `shortcutsBlocked`
 * (`client/src/lib/keyboard.ts`) stands the window shortcuts down while an
 * input has focus, so without this Enter on a focused rating would do nothing
 * (pedagogy spec §4.3.2). Only radios and checkboxes take part: a text field
 * inside the same wrapper keeps its own keys.
 */
import type { KeyboardEvent } from "react";

export interface AnswerKeyActions {
  /** The step's primary action: submit, or "Klar" on an open question. */
  submit: () => void;
  /** Opens the next hint. */
  hint?: () => void;
}

export function answerKeyDown(actions: AnswerKeyActions) {
  return (event: KeyboardEvent<HTMLElement>): void => {
    if (event.defaultPrevented) return;
    if (event.repeat) return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== "radio" && target.type !== "checkbox") return;
    if (event.key === "Enter" || event.key === "s" || event.key === "S") {
      event.preventDefault();
      actions.submit();
    } else if ((event.key === "h" || event.key === "H") && actions.hint) {
      event.preventDefault();
      actions.hint();
    }
  };
}
